<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="">会员展示</router-link></li>
                 <li class="currentNode"><a>会员详情</a></li>
            </ul>
            <div class="page-main">
               <div class="page-main-tp">
                    <img src="@/assets/image/enterprise/enterpriseBranch1.png" />
                    <div class="brief-introduction">
                        <h3>北京趣拿信息技术有限公司</h3>
                        <p><span>主营业务：</span>技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；软件开发；数字技术服务；数据处理服务；会议及展览服务；社会经济咨询服务；计算机系统服务；市场调查（不含涉外调查）；组织文化艺术交流活动。</p>
                        <p class="contact-people"><span>公司联系人：</span><a>****** （点击查看公司联系人信息）</a></p>
                        <button>加入协会</button>
                    </div>
                </div>
                <div class="page-main-btm">
                    <h4>公司简介</h4>
                    <el-divider></el-divider>
                    <p>中兴通讯是一家综合通信解决方案提供商，为全球电信运营商、政企客户及个人消费者提供创新的技术与产品解决方案 [122]。公司成立于1985年，在香港和深圳两地上市，业务覆盖160多个国家和地区，服务全球1/4以上人口 [123]。中兴通讯拥有通信业界完整的、端到端的产品线和融合解决方案，通过全系列的无线、有线、业务、终端产品和专业通信服务，灵活满足全球不同运营商和政企客户的差异化及快速创新的需求 [122]。截至2023年，中兴通讯拥有8.65万余件全球专利申请、历年全球累积授权专利约4.4万件 [124]。据2021年，投资管理公司仲量联行发布《中国通信行业及知识产权市场报告》显示，中兴通讯的专利技术价值已超过450亿元人民币 [125]。在中国专利奖评奖中，累计获得10金2银38优秀的成绩 [126]，在通信行业中排名第一 [127]。</p>
                    <p>2022年，中兴通讯进入战略超越期，中兴通讯在作为第一曲线的CT业务稳步固本同时，积极打造公司增长第二曲线，包括IT（包括服务器及存储等IT基础设施以及5G行业，汽车电子等数字化转型业务），数字能源（包括电源、IDC数据中心、新能源等），终端（包括手机、移动互联、智慧家庭等）等领域。中兴通讯成立了矿山、冶金钢铁、东数西算、汽车电子等行业特战队，加快5G垂直应用深度拓展 [122]。</p>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    name:"",
    data() {
        return {
            total: 100,
            currentPage: 1,
            pageSize: 10,
            tableData:[{
                "address":"李强签署国务院令 公布《生态保护补偿条例》",
                "date":"2023-10-11"
            },
            {
                "address":"国家发展改革委有关负责同《国家发展改革委部门关于支持内蒙古绿色低碳高质量发展若干政策措施的通知》",
                "date":"2023-10-11"
            }],         
        }
    },
    created() {
        this.page = this.$route.query.page;
        console.log(this.data);
    },
    methods: {
        handleCurrentChange(pageNum) {

        }
    }
}
</script>

<style scoped>
.page-main{
    display: block;
    background: #fff;
    padding: 30px;
    box-sizing: border-box;
}
.page-main-tp {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.page-main-tp img {
    width: 167px;
    height: 167px;
    border: 1px solid #E5E5E5;
}
.brief-introduction {
    margin-left:30px;
}
.brief-introduction h3{
    font-size: 26px;
    color: #262626;
    margin-bottom: 20px;
}
.brief-introduction  p {
    font-family: 思源黑体 CN;
    font-size: 14px;
    color: #6A6A6A;
    line-height: 26px;
}
.brief-introduction p:last-of-type {
    margin-bottom:20px;
}
.brief-introduction button {
    width: 129px;
    height: 30px;
    line-height: 30px;
    background: #116EBA;
    color: #fff;
    text-align: center;
    outline: 0;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    box-sizing: border-box;
    border: none;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    font-size: 14px;
}
.contact-people a {
    cursor:pointer;
}
.page-main-btm h4 {
    color: #262626;
    font-size: 22px;
    margin: 20px 0;
}
.page-main-btm p{
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28.64px;
    color: #4E5969;
    text-indent: 2em;
    white-space: pre-wrap;
    margin-bottom: 20px;
}
 
</style>